import baseApi from "./api.service";
import { PaymentRequest } from "@/models/api/PaymentRequest";
import { PaymentResponse } from "@/models/api/PaymentResponse";
import { PayResult } from "@/models/www/PayResult"
import { PaymentInitResult } from "@/models/www/PaymentInitResult";
import { PaymentInitResponse } from "@/models/api/PaymentInitResponse";

const paymentService = {
	init(): Promise<PaymentInitResult> {
		return new Promise((resolve, reject) => {
			baseApi.post<PaymentInitResponse>("payment/init", {})
				.then(resp => resolve(new PaymentInitResult(resp)))
				.catch(err => reject(err))
		})
	},
	start(paymentRequest: PaymentRequest): Promise<PayResult> {
		return new Promise((resolve, reject) => {
			baseApi.post<PaymentResponse>("payment/start", paymentRequest)
				.then(resp => resolve(new PayResult(resp)))
				.catch(err => reject(err))
		})
	},
	validateCard(cardNumber: string) : Promise<boolean> {
			
			return new Promise((resolve, reject) => {
					
					if (cardNumber.startsWith('3') == true &&
						  cardNumber.length == 15) {
							reject({ message: 'Unfortunately you cannot pay for your travel with an AMEX card'});
					}
					else {
							resolve(true);
					}
			})
	}
}

export default paymentService;